import { CalendarDays, ExternalLink, FileText, Megaphone } from "lucide-react";
import { getTaskDisplayName } from "@/utils/taskDisplay";
import { formatCalendarDate } from "@/utils/dateDisplay";

export const TaskWorkInfoBanner = ({ task }) => {
  const days = task.remaining_days;
  const overdue = days != null && days < 0;
  const urgent = days != null && days >= 0 && days <= 3;
  const countdown = days == null ? "Sisa waktu tidak tersedia" : overdue ? `Terlambat ${Math.abs(days)} hari` : days === 0 ? "Berakhir hari ini" : `Tersisa ${days} hari`;

  return (
    <section className="task-work-info" data-testid="task-work-info-card">
      <div className="task-work-info-heading"><FileText size={15} /><span>INFORMASI PEKERJAAN</span></div>
      <div className="task-work-info-grid">
        <div><small>Nama Task</small><strong data-testid="task-work-info-nama">{getTaskDisplayName(task)}</strong></div>
        <div><small>Deadline Task</small><strong data-testid="task-work-info-deadline"><CalendarDays size={14} /> {formatCalendarDate(task.deadline, "long")}</strong></div>
        <div className="task-work-info-announcement">
          <small>Pengumuman</small>
          {task.announcement_link ? <a href={task.announcement_link} target="_blank" rel="noreferrer" data-testid="task-work-info-announcement-link"><Megaphone size={14} /> Baca Pengumuman <ExternalLink size={12} /></a> : <span data-testid="task-work-info-announcement-empty">Belum tersedia</span>}
        </div>
      </div>
      {task.additional_information && <div className="task-work-additional" data-testid="task-work-info-additional"><small>Informasi Tambahan</small><p>{task.additional_information}</p></div>}
      <span className={`task-work-countdown ${overdue ? "danger" : urgent ? "warning" : "info"}`} data-testid="task-work-info-countdown">{countdown}</span>
    </section>
  );
};